export const FILE_SIZE = 'FILE_SIZE';
export const UNSUPPORTED_TYPE = 'unsupported_type';